import { Dropdown } from 'react-bootstrap';
import classes from './Button.module.css';
import clsx from 'clsx';
import { ArrowDownIcon } from '../../../Assets/icons';
import PopoverBox from '../Popover';
const Button = ({
  variants = 'primary',
  label,
  className,
  disabled,
  leftIcon,
  isSelected,
  children,
  onClick = () => {},
  type = 'button',
  list = [],
  onButtonClick = () => {},
  dropdown
}) => {
  let content = children || label;
  if (leftIcon) {
    content = [leftIcon, label && <> {label}</>];
  }
  if (dropdown) {
    content = (
      <span className={classes.withMultipleAction}>
        {leftIcon}{' '}
        <span className={classes.centerLabel} onClick={onButtonClick}>
          {label}
        </span>
        <PopoverBox list={list}>
          <span className={classes.arrowRadius}>
            <ArrowDownIcon />
          </span>
        </PopoverBox>
      </span>
    );
  }
  return (
    <button
      disabled={disabled}
      className={clsx(
        classes.button,
        {
          [classes.primary]: variants === 'primary',

          [classes.secondary]: variants === 'secondary',
          [classes.withIcon]: variants === 'role',
          [classes.selected]: variants === 'role' && isSelected,
          [classes.paginationBtn]: variants === 'pageBtn',
          [classes.viewBtn]: variants === 'view',
          [classes.cancel]: variants === 'cancel',
          [classes.confirm]: variants === 'confirm',
          [classes.iconBtn]: variants === 'iconBtn',
          [classes.tabBtn]: variants === 'tabBtn',
          [classes.accent]: variants === 'accent',
          [classes.transparent]: variants === 'transparent',
          [classes.add]: variants === 'add',
          [classes.danger]: variants === 'danger'
        },
        className
      )}
      onClick={(e) => {
        onClick();
      }}
      type={type}>
      {content}
    </button>
  );
};

export default Button;
